import { HStack, StackProps, VStack } from "@chakra-ui/layout";
import { Avatar, forwardRef, Text } from "@chakra-ui/react";
import React from "react";

export enum AVATAR_CARD_MODES {
  SHORT,
  FULL,
}

export const AvatarCard = forwardRef<StackProps, "div">(
  (
    {
      author: {
        node: { firstName, lastName, name, avatar },
      },
      mode = AVATAR_CARD_MODES.FULL,
      ...props
    },
    ref
  ) => {
    const fullName = `${firstName} ${lastName || ''}`;
    const avatarSize = mode === AVATAR_CARD_MODES.FULL ? 'md' : 'sm';
    const nameFontSize = mode === AVATAR_CARD_MODES.FULL ? '16px' : '12px';

    return (
      <HStack ref={ref} {...props} d="flex">
        {avatar && (
          <Avatar
            size={avatarSize}
            src={avatar.url}
            alt="avatar"
            mr="1rem"
          />
        )}
        <VStack align="flex-start" spacing="0">
          <Text fontSize={nameFontSize} fontWeight="700" my="5px">
            {fullName}
          </Text>
          {mode === AVATAR_CARD_MODES.FULL && fullName !== name && (
            <Text color="#CAC7C7" fontSize="11px">
              {name}
            </Text>
          )}
        </VStack>
      </HStack>
    )
  }
);
